import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import store from '@/store';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { getCreativeTemplateApi } from '@/api/creative';
import { getDeliveryPositionApi } from '@/api/tool/delivery-position';

/**
 * 管理VIVO渠道的数据
 */
export default class VivoDataSourceController extends DataSourceController {
  /**
   * 获取投放内容
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: `${name}（${id}）`, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getConvertGoalListApi(params);
      const result = (ret?.list || []).map(({ id, name, is_roi }) => ({ label: name, value: id, is_roi }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepConvertGoalApi(params);
      const result = (ret?.list || []).map(({ id, name, is_roi }) => ({ label: name, value: id, is_roi }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取过滤已转化用户天数列表
   * @returns {Promise<Object[]>}
   */
  getConvertedUserFilterDaysList() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_converted_user_filter_days : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取创意规格列表
   * @param {Object} params 查询参数
   * @returns {Promise<Object[]>}
   */
  getCreativeTemplateList(params = {}) {
    return new Promise((resolve, reject) => {
      const payload = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...params,
      };
      getCreativeTemplateApi(payload).then(res => {
        const result = (res?.list || []).map(({ id, name }) => ({ label: name, value: id }));
        resolve(result);
      }).catch(reject);
    });
  }

  /**
   * 获取投放位置列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryPosition(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeliveryPositionApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
